import { NgModule } from '@angular/core';
import { LdmDatePipe } from './pipes/ldm-date.pipe';

@NgModule({
    declarations: [LdmDatePipe],
    exports: [LdmDatePipe],
    imports: [],
})
export class LdmCoreModule { }
